fle<template>
  <div style="position: relative;background-color: #151419;color: #fff;" class="w100 minwidth mw100">
    <tabbar></tabbar>

    <!-- <div>
      <carousel style="position: relative;z-index: 0; width: 100%"></carousel>
    </div> -->

    <div style="width: 100%;position: relative;margin-bottom: 1%;">
      <img style="width: 100%;height: auto;" :src="require('../../public/img/main/main_banner.png')" alt="">
      <div style="position: absolute;top: 70%;left: 50%;transform: translate(-50%);width: 70%;">
        <img style="width: 100%;height: auto;" :src="require('../../public/img/main/main_subbanner.png')" alt="">
      </div>
    </div>

    <div class="pcScreen" style="width: 70%;margin: 0 auto;margin-bottom: 3%;">
      <div style="font-size: max(25px,2.5vw);font-weight: bold;letter-spacing: 0.1em;">核心能力</div>
      <div style="font-size: max(10px,1vw);font-weight: bold;margin-top: 0.5%;">CORE COMPETENCIES</div>
      <div style="width: 100%;display: flex;justify-content: space-between;align-items: center;margin-top: 3%;">
        <div style="width: 22%;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture5.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
            <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              推广信息服务
            </div>
            <div style="font-size: max(8px,0.8vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;text-align: justify;">
              通过对用户行为偏好的深度洞察与智能分析，精准定位目标客群，实现营销信息的高效传递与场景化渗透
            </div>
          </div>
        </div>
        <div style="width: 22%;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture6.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
            <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              权益信息服务
            </div>
            <div style="font-size: max(8px,0.8vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;text-align: justify;">
              通过整合互联网权益，联合运营商的管道能力打造独家会员，提供基于促活维系、策反、提升价值等一系列操作的核心抓手
            </div>
          </div>
        </div>
        <div style="width: 22%;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture7.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
            <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              运营信息服务
            </div>
            <div style="font-size: max(8px,0.8vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;text-align: justify;">
              承接运营商的产品运营需求，提供产品设计、系统研发、营销策划、推广监控、客服支撑等全链路运营服务
            </div>
          </div>
        </div>
        <div style="width: 22%;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture8.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 45%;">
            <div style="font-size: max(15px,1.5vw);font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              生态合作紧密
            </div>
            <div style="font-size: max(8px,0.8vw);width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;text-align: justify;">
              与头部互联网平台己形成深入的技术对接和业务融合，可加速新项目的启动和落地。权益商城搭建、权益内容代运营、权益体系定制方案
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobileScreen" style="width: 95%;margin: 0 auto;margin-bottom: 3%;">
      <div style="font-size: 3.5vw;font-weight: bold;letter-spacing: 0.1em;width: 90%;margin: 0 auto;">企业愿景</div>
      <div style="font-size: 2vw;font-weight: bold;margin-top: 0.5%;width: 90%;margin: 0 auto;">CORPORATE CULTURE</div>
      <div style="width: 90%;margin: 0 auto;display: flex;justify-content: space-between;align-items: center;margin-top: 3%;flex-wrap: wrap;">
        <div style="width: 50%;margin: 0 auto;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture5.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 35%;">
            <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              推广信息服务
            </div>
            <div style="font-size: 1.7vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
              通过对用户行为偏好的深度洞察与智能分析，精准定位目标客群，实现营销信息的高效传递与场景化渗透
            </div>
          </div>
        </div>
        <div style="width: 50%;margin: 0 auto;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture6.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 35%;">
            <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              权益信息服务
            </div>
            <div style="font-size: 1.7vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
              通过整合互联网权益，联合运营商的管道能力打造独家会员，提供基于促活维系、策反、提升价值等一系列操作的核心抓手
            </div>
          </div>
        </div>
        <div style="width: 50%;margin: 0 auto;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture7.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 35%;">
            <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              运营信息服务
            </div>
            <div style="font-size: 1.7vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
              承接运营商的产品运营需求，提供产品设计、系统研发、营销策划、推广监控、客服支撑等全链路运营服务
            </div>
          </div>
        </div>
        <div style="width: 50%;margin: 0 auto;position: relative;">
          <img style="width: 100%;height: auto;display: block;"
            :src="require('../../public/img/main/main_culture8.png')" alt="">
          <div
            style="background-color: rgba(0, 0, 0, 0.6);position: absolute;bottom: 0;width: 100%;color: #C5B497;height: 35%;">
            <div style="font-size: 2.8vw;font-weight: bold;width: 90%;margin: 0 auto;margin-top: 3%;">
              生态合作紧密
            </div>
            <div style="font-size: 1.7vw;width: 90%;margin: 0 auto;margin-top: 3%;line-height: 2;">
              与头部互联网平台己形成深入的技术对接和业务融合，可加速新项目的启动和落地。权益商城搭建、权益内容代运营、权益体系定制方案
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="pcScreen" style="width: 70%;margin: 0 auto;margin-bottom: 3%;">
      <div style="font-size: max(25px,2.5vw);font-weight: bold;letter-spacing: 0.1em;">信息服务优势</div>
      <div style="font-size: max(10px,1vw);font-weight: bold;margin-top: 0.5%;">SERVICE ADVANTAGES</div>
      <div
        style="width: 100%;display: flex;justify-content: flex-end;color: #C5B497;position: relative;margin-top: 3%;padding-top: 3%;">
        <div style="width: 90%;background-color: #25242A;display: flex;justify-content: flex-end;border-radius: 0.2em;">
          <div style="width: 82%;padding: 3% 0;font-size: max(8px,0.8vw);">
            <div style="display: flex;">
              <div style="flex: 1;">
                <div style="display: flex;align-items: center;">
                  <img style="width: 4%;height: auto;display: block;"
                    :src="require('../../public/img/main/main_icon1.png')" alt="">
                  <span style="margin-left: 2%;font-size: max(12px,1.2vw);font-weight: 500;">场景痛点</span>
                </div>
                <div style="color: #fff;width: 85%;margin-left: 6%;color: #999999;margin-top: 2%;">
                  市场竞争激烈，产品信息很容易被淹没在海量信息中，难以有效抓住目标用户的注意力。
                </div>
              </div>
              <div style="flex: 1;">
                <div style="display: flex;align-items: center;">
                  <img style="width: 4%;height: auto;display: block;"
                    :src="require('../../public/img/main/main_icon2.png')" alt="">
                  <span style="margin-left: 2%;font-size: max(12px,1.2vw);font-weight: 500;">服务方案</span>
                </div>
                <div style="color: #fff;width: 85%;margin-left: 6%;color: #999999;margin-top: 2%;">
                  智能化个性化推送：基于用户行为数据、兴趣偏好和购买历史，通过智能算法分析，精确推送符合用户需求的产品信息。
                </div>
              </div>
            </div>
            <div style="margin-top: 2%;">
              <div style="display: flex;align-items: center;">
                <img style="width: 2%;height: auto;display: block;"
                  :src="require('../../public/img/main/main_icon3.png')" alt="">
                <span style="margin-left: 1%;font-size: max(12px,1.2vw);font-weight: 500;">方案成效</span>
              </div>
              <div style="color: #fff;width: 90%;margin-left: 3%;color: #999999;margin-top: 1%;">
                通过精准的个性化推送和创意内容，显著提高广告的点击率和转化率，有效吸引目标用户的关注。<br>
                基于数据分析和实时反馈，优化推广策略，实现高效的广告投放和资源利用，提升推广ROI。<br>
                精准的用户画像和定向推广提高了产品对潜在客户的吸引力，有效促进销售增长。
              </div>
            </div>
          </div>
        </div>
        <div style="position: absolute;left: 0;top: 0;width: 21%;">
          <div style="position: relative;">
            <img style="width: 100%;height: auto;display: block;border-radius: 0.2em;"
              :src="require('../../public/img/main/main_culture4.png')" alt="">
            <div
              style="background-color: rgba(0, 0, 0, 0.6);position: absolute;top: 55%;transform: translateY(-50%);width: 100%;height: 30%;color: #C5B497;display: flex;align-items: center;justify-self: center;">
              <div style="font-size: max(12px,1.2vw);font-weight: bold;width: 60%;margin: 0 auto;">
                产品信息流推广<br>
                服务解决方案
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mobileScreen" style="width: 95%;margin: 0 auto;margin-bottom: 5%;">
      <div style="font-size: 3.5vw;font-weight: bold;letter-spacing: 0.1em;width: 90%;margin: 0 auto;">信息服务优势</div>
      <div style="font-size: 2vw;font-weight: bold;margin-top: 0.5%;width: 90%;margin: 0 auto;">SERVICE ADVANTAGES</div>
      <div
        style="width: 100%;display: flex;justify-content: center;color: #C5B497;position: relative;margin-top: 1%;padding-top: 3%;">
        <div style="width: 90%;background-color: #25242A;display: flex;justify-content: center;border-radius: 0.2em;">
          <div style="width: 90%;padding: 3% 0;font-size: max(8px,0.8vw);">
            <div style="display: flex;">
              <div style="flex: 1;">
                <div style="display: flex;align-items: center;">
                  <img style="width: 4%;height: auto;display: block;"
                    :src="require('../../public/img/main/main_icon1.png')" alt="">
                  <span style="margin-left: 2%;font-size: max(12px,1.2vw);font-weight: 500;">场景痛点</span>
                </div>
                <div style="color: #fff;width: 85%;margin-left: 6%;color: #999999;margin-top: 2%;">
                  市场竞争激烈，产品信息很容易被淹没在海量信息中，难以有效抓住目标用户的注意力。
                </div>
              </div>
              <div style="flex: 1;">
                <div style="display: flex;align-items: center;">
                  <img style="width: 4%;height: auto;display: block;"
                    :src="require('../../public/img/main/main_icon2.png')" alt="">
                  <span style="margin-left: 2%;font-size: max(12px,1.2vw);font-weight: 500;">服务方案</span>
                </div>
                <div style="color: #fff;width: 85%;margin-left: 6%;color: #999999;margin-top: 2%;">
                  智能化个性化推送：基于用户行为数据、兴趣偏好和购买历史，通过智能算法分析，精确推送符合用户需求的产品信息。
                </div>
              </div>
            </div>
            <div style="margin-top: 2%;">
              <div style="display: flex;align-items: center;">
                <img style="width: 2%;height: auto;display: block;"
                  :src="require('../../public/img/main/main_icon3.png')" alt="">
                <span style="margin-left: 1%;font-size: max(12px,1.2vw);font-weight: 500;">方案成效</span>
              </div>
              <div style="color: #fff;width: 90%;margin-left: 3%;color: #999999;margin-top: 1%;">
                通过精准的个性化推送和创意内容，显著提高广告的点击率和转化率，有效吸引目标用户的关注。<br>
                基于数据分析和实时反馈，优化推广策略，实现高效的广告投放和资源利用，提升推广ROI。<br>
                精准的用户画像和定向推广提高了产品对潜在客户的吸引力，有效促进销售增长。
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <bottom></bottom>

    <!-- <customerservice></customerservice> -->

  </div>
</template>

<script>
  import Tabbar from "../components/Tabbar.vue";
  import Bottom from "../components/Bottom.vue";
  import Carousel from "../components/Carousel.vue";

  export default {
    components: { Tabbar, Bottom, Carousel },
    data() {
      return {

      };
    },

    methods: {

    },
  };
</script>

<style scoped>
  * {
    margin: 0;
    padding: 0;
  }

  .bgtype>>>.tabFont {
    color: #ffffff;
  }

  .bgtype>>>.tabFont:hover {
    color: rgb(233 192 131);
  }

  .bgtype>>>.tabListBut {
    color: #ffffff;
  }

  a {
    text-decoration: none;
    color: #000;
  }

  .w100 {
    width: 100%;
  }

  .minwidth {
    min-width: 1000px;
  }

  .pcScreen {
    display: block;
  }

  .mobileScreen {
    display: none;
  }

  @media screen and (max-width: 750px) {
    .pcScreen {
      display: none;
    }

    .mobileScreen {
      display: block;
    }

    .minwidth {
      min-width: 0px;
    }

    .mw100 {
      width: 100vw;
    }
  }
</style>